import {FormattedMessage} from "react-intl"
import React from "react"
import moment from "moment"

export default {
	load() {
		return {
			fields: {
				datefrom: {
					label: <FormattedMessage id="Capitation.List.From" />,
					type: "date",
					value: moment().startOf("month")
				},
				dateto: {
					label: <FormattedMessage id="Capitation.List.To" />,
					type: "date"
				},
				number: {
					label: <FormattedMessage id="Common.label.number" />,
					type: "string"
				}
			}
		}
	}
}
